import React from 'react';
import {connect} from 'react-redux';
import ModalSnapshot from './ModalSnapshot';
import logo from '../../assets/images/specimen_original.png';
import SnapShotListItem from './SnapShotListItem';
import {getSnapshots} from "../../redux/actions";
import Aox from '../hoc/Aox';

const renderSnapshotItems = (props) => {
  if (!props.snapshots.length) {
    return null;
  }

  return props.snapshots.map(item => (
    <SnapShotListItem
      key={item._id}
      id={item._id}
      url={item.snapshotUrl}
      snapshot={item}
      renderSavedSnapshot={props.renderSavedSnapshot}
    />
  ));
};

const SnapShots = (props) => {
  return (
    <div className="snapshot-wrapper grey-wrapper">
      {
        props.isCaseLevelActive ?
          null :
          <Aox>
            <span className="snapshot-title">original specimen</span>
            <div className="snapshot-original-specimen" onClick={() => props.renderOriginalSpecimen()}>
              <img src={logo} alt="snapshot"/>
            </div>

            <ModalSnapshot
              cancelSnapshot={props.cancelSnapshot}
              handleSnapshotActivated={props.handleSnapshotActivated}
              tempSnapshotId={props.tempSnapshotId}
              tempSnapshotUrl={props.tempSnapshotUrl}
              isModalOpen={props.isModalOpen}
              handleSnapshotSaved={props.handleSnapshotSaved}
            />
          </Aox>
      }

      {
        props.snapshots.length ? <span className="snapshot-title">saved snapshots:</span> : null
      }

      <div className="snapshot-wrapper-scroll">
        { renderSnapshotItems(props) }
      </div>
    </div>
  );


};

const mapStateToProps = ({_case, snapshot}) => {
  const {specimens, selectedSpecimen} = _case;
  const {snapshots} = snapshot;
  return {
    specimens,
    snapshots,
    selectedSpecimen,
  };
};

export default connect(mapStateToProps, {getSnapshots})(SnapShots);
